import type { ConnectorState } from '../connector-promo-config-types.ts';

/**
 * Placeholder hook that will eventually query admin_getAllDataSources via AGG
 * to get the current state of all third-party connectors for the tenant.
 *
 * Each AdminConnector has a type (e.g. 'google-drive', 'github') and a list
 * of AdminDataSource entries. A connector is considered "set up" when it has
 * at least one AdminDataSource with enabled === true.
 *
 * @returns Record mapping connector type keys to their ConnectorState
 */
export function useConnectorStates(): Record<string, ConnectorState> {
	// TODO(TWCG-1489): Query admin_getAllDataSources and transform the response:
	// - For each AdminConnector, check if datasources contains an enabled entry
	// - Map AdminFormConfiguration.connectorDisplayName to displayName
	// - Key by AdminConnector.type
	return {};
}
